import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Drawer, Divider, Paper, Avatar, Typography, Button } from '@material-ui/core';
import { Hidden } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import useRouter from 'utils/useRouter';
import { Navigation } from 'components';
import navigationConfig from './navigationConfig';
import useStyles from './style';
import { SettingPopover } from 'components';

const NavBar = props => {
  const { openMobile, onMobileClose, user, avatar, className, handleLogout, roles, currentAccount, ...rest } = props;
  const settingRef = useRef(null);
  const classes = useStyles();
  const router = useRouter();
  const [openSetting, setOpenSetting] = useState(false);
  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.location.pathname]);

  const handleSettingOpen = () => {
    setOpenSetting(true);
  };

  const handleSettingClose = () => {
    setOpenSetting(false);
  };

  const navbarContent = (
    <div className={classes.content}>
      <div className={classes.profile}>
        {user && <><Avatar
          alt="Store"
          className={classes.avatar}
          component={RouterLink}
          src={avatar}
          to="/settings/general"
        />
        <Typography
          className={classes.name}
          variant="h4"
        >
          {user.store.name}
        </Typography>
        <Typography variant="body2">{user.operator.email}</Typography>
        </>
        }
      </div>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {navigationConfig.map(list => (
          <Navigation
            component="div"
            key={list.title}
            pages={list.pages}
            title={list.title}
          />
        ))}

        <Hidden lgUp>
          {roles && roles.length > 1 && <Button
            className={classes.logoutButton}
            color="inherit"
            onClick={handleSettingOpen}
            ref={settingRef}
          >
            <SettingsOutlinedIcon className={classes.logoutIcon} />
            Settings
          </Button>}
          {currentAccount && roles && roles.length > 1 && <SettingPopover
            anchorEl={settingRef.current}
            roles={roles}
            onClose={handleSettingClose}
            open={openSetting}
            currentAccount={currentAccount}
          />}
        </Hidden>
        <Hidden lgUp>
          <Button
            color="inherit"
            className={classes.logoutButton}
            onClick={handleLogout}
          >
            <InputIcon className={classes.logoutIcon} />
            Sign out
          </Button>
        </Hidden>
        <Typography variant="body2" className={classes.version}>
          v {process.env.REACT_APP_VERSION}
        </Typography>
      </nav>
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <div
            {...rest}
            className={clsx(classes.root, className)}
          >
            {navbarContent}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper
          {...rest}
          className={clsx(classes.root, className)}
          elevation={1}
          square
        >
          {navbarContent}
        </Paper>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  currentAccount: PropTypes.any,
  roles: PropTypes.array,
};

NavBar.defaultProps = {
  roles: [],
  currentAccount: null,
}

export default NavBar;
